import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="indicaciones-buffer"
export default class extends Controller {
  static targets = ["bufferFieldFarmacologica", "bufferFieldParenteral", "list", "materialNombre", "materialCodigo", "materialFNombre", "materialFCodigo", "guardarFarmacologicaButton", "guardarParenteralButton"]

  connect() {
    this.buffer = []
  }

  agregarIndicacion(event) {
    event.preventDefault()

    const form = event.target.closest("form")
    const formData = new FormData(form)
    const indicacion = {}

    const descripcionMaterial = form.querySelector('[data-indicaciones-buffer-target="materialNombre"]')?.value ||
    form.querySelector('[data-indicaciones-buffer-target="materialFNombre"]')?.value || "-"
    indicacion["MaterialNombre"] = descripcionMaterial

    const codigoMaterial = form.querySelector('[data-indicaciones-buffer-target="materialCodigo"]')?.value ||
    form.querySelector('[data-indicaciones-buffer-target="materialFCodigo"]')?.value || "-"
    indicacion["MaterialCodigo"] = codigoMaterial

    const atributosValidos = [
      "matricula_for_print", "Interno", "tipo_indicacion", "Estado",
      "Fecha", "hora", "tipo", "volumen",
      "via_asignacion", "velocidad", "Cantidad", "Observaciones", "type",
      "Registro", "Hoja", "medicacion_habitual", "unidad", "Intervalo", "agregados"
    ]

    formData.forEach((value, key) => {
      const match = key.match(/\[([^\]]+)\]$/)
      const cleanKey = match ? match[1] : key

      if (atributosValidos.includes(cleanKey)) {
        indicacion[cleanKey] = value
      }
    })

    const indicaion_agregados = []
    const agregadosWrappers = form.querySelectorAll(".agregados-form-wrapper")

    agregadosWrappers.forEach(wrapper => {
      const codigo = wrapper.querySelector('[name*="[MaterialCodigo]"]')?.value
      const cantidad = wrapper.querySelector('[name*="[cantidad]"]')?.value
      const unidad = wrapper.querySelector('[name*="[unidad_agregados]"]')?.value

      if (codigo && cantidad && unidad) {
        indicaion_agregados.push({
          CodigoMaterial: codigo,
          cantidad: cantidad,
          unidad_agregados: unidad
        })
      }
    })

    indicacion["indicacion_agregados"] = indicaion_agregados

    this.buffer.push(indicacion)
    this.renderLista()

    form.reset()

    const validatorController = this.application.getControllerForElementAndIdentifier(form, "form-validator")
    if (validatorController) validatorController.validate()
  }

  renderLista() {
    this.listTarget.innerHTML = this.buffer.map((item, index) => {
      return `
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <span>
            <strong>${item.MaterialNombre || item.MaterialCodigo || '-'}</strong> |
            ${this.translateTipoIndicacion(item.tipo_indicacion) || '-'} |
            Observaciones: ${item.Observaciones || '-'}
          </span>
          <button type="button" class="btn btn-danger btn-sm" data-action="indicaciones-buffer#quitarIndicacion" data-index="${index}">
            <span class="fas fa-minus"></span>
          </button>
        </li>
      `
    }).join("")

    this.bufferFieldFarmacologicaTarget.value = JSON.stringify(this.buffer)
    this.bufferFieldParenteralTarget.value = JSON.stringify(this.buffer)

    if (this.guardarParenteralButtonTarget) {
      this.guardarParenteralButtonTarget.classList.toggle("d-none", this.buffer.length === 0)
    }

    if (this.guardarFarmacologicaButtonTarget) {
      this.guardarFarmacologicaButtonTarget.classList.toggle("d-none", this.buffer.length === 0)
    }
  }

  quitarIndicacion(event) {
    const index = event.currentTarget.dataset.index
    this.buffer.splice(index, 1)
    this.renderLista()
  }

  translateVolumen(value) {
    const volumenes = {
      "ml_100": "100 ml",
      "ml_150": "150 ml",
      "ml_200": "200 ml",
      "ml_250": "250 ml",
      "ml_500": "500 ml",
      "ml_750": "750 ml",
      "ml_1000": "1000 ml",
      "ml_1500": "1500 ml",
      "ml_2000": "2000 ml",
      "ml_2500": "2500 ml",
      "ml_3000": "3000 ml"
    }
    return volumenes[value] || "-"
  }

  translateVia(value) {
    const vias = {
      "endovenosa": "Endovenosa",
      "inhalatoria": "Inhalatoria"
    }
    return vias[value] || "-"
  }

  translateTipoIndicacion(value) {
    const indicaciones = {
      "farmacologica": "Farmacológica",
      "parenterales": "Parenteral"
    }
    return indicaciones[value] || "-"
  }

  translateVelocidad(value) {
    const velocidades = {
      "goteo": "Goteo",
      "bomba": "Bomba"
    }
    return velocidades[value] || "-"
  }

}
